import { Controller } from "@hotwired/stimulus"

declare const Stripe: any
declare const NProgress: any

export default class extends Controller {
  static targets = [
    "quantitySelect", 
    "totalPrice", 
    "form", 
    "existingCardSection", 
    "newCardSection", 
    "cardElement", 
    "submitButton"
  ]
  static values = {
    pricePerReminder: Number,
    stripeKey: String,
    fullName: String
  }

  declare quantitySelectTarget: HTMLSelectElement
  declare totalPriceTarget: HTMLElement
  declare formTarget: HTMLFormElement
  declare existingCardSectionTarget: HTMLElement
  declare newCardSectionTarget: HTMLElement
  declare cardElementTarget: HTMLElement
  declare submitButtonTarget: HTMLInputElement
  declare pricePerReminderValue: number
  declare stripeKeyValue: string
  declare fullNameValue: string
  declare hasExistingCardSectionTarget: boolean

  private stripe: any
  private card: any
  private usingNewCard: boolean = false

  connect() {
    this.usingNewCard = !this.hasExistingCardSectionTarget
    if (this.usingNewCard) {
      this.initializeStripe()
    }
  }

  updateTotal() {
    const quantity = parseInt(this.quantitySelectTarget.value)
    const totalCents = quantity * this.pricePerReminderValue
    const totalDollars = (totalCents / 100).toFixed(2)
    
    this.totalPriceTarget.textContent = `$${totalDollars}`
  }

  showNewCardForm() {
    this.existingCardSectionTarget.classList.add('hidden')
    this.newCardSectionTarget.classList.remove('hidden')
    this.usingNewCard = true
    this.initializeStripe()
  }

  showExistingCardForm() {
    this.newCardSectionTarget.classList.add('hidden')
    this.existingCardSectionTarget.classList.remove('hidden')
    this.usingNewCard = false
  }

  initializeStripe() {
    if (this.stripe) return

    this.stripe = Stripe(this.stripeKeyValue)
    const elements = this.stripe.elements({
      fonts: [
        { cssSrc: '//fonts.googleapis.com/css?family=Lato:400,400italic,700,700italic' }
      ],
      locale: 'auto'
    })

    const elementStyles = {
      base: {
        fontFamily: 'Lato',
        fontSize: '18px'
      }
    }

    this.card = elements.create('card', { iconStyle: 'solid', hidePostalCode: true, style: elementStyles })
    this.card.mount(this.cardElementTarget)
  }

  async submit(event: Event) {
    if (!this.usingNewCard) {
      // Let the form submit normally for existing card
      if (typeof NProgress !== 'undefined') NProgress.start()
      return
    }

    event.preventDefault()
    if (typeof NProgress !== 'undefined') NProgress.start()
    
    this.submitButtonTarget.disabled = true

    const { token, error } = await this.stripe.createToken(this.card, {
      name: this.fullNameValue
    })

    if (error) {
      const errorElement = document.getElementById('card-errors')
      if (errorElement) errorElement.textContent = error.message
      this.submitButtonTarget.disabled = false
      if (typeof NProgress !== 'undefined') NProgress.done()
    } else {
      this.stripeResponseHandler(token)
    }
  }

  stripeResponseHandler(token: any) {
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripe_token')
    hiddenInput.setAttribute('value', token.id)
    this.formTarget.appendChild(hiddenInput)
    
    this.formTarget.submit()
  }
}
